// T35 (Titipan auditor 27 Okt 2026): tombol bulat "Kembali ke atas" (pojok kanan bawah, melayang) pernah MENIMPA menu
// PRODUKSI › "Laporan Balik Telegram". Tombol itu tidak boleh menutupi navigasi di ukuran layar mana pun: bila
// sidebar / panel menu (Versi B) / bilah bawah menempati pojok tombol, tombolnya disembunyikan.

/** Kotak [kiri, atas, kanan, bawah] tombol di pojok kanan bawah (bottom-5 right-5, 40×40) + jarak aman 8 px. */
export function zonaTombol(lebar, tinggi, { ukuran = 40, tepi = 20, aman = 8 } = {}) {
  return [lebar - tepi - ukuran - aman, tinggi - tepi - ukuran - aman, lebar - tepi + aman, tinggi - tepi + aman];
}

/** Dua kotak [kiri, atas, kanan, bawah] bertumpuk? Kotak kosong (lebar/tinggi 0) tidak pernah bertumpuk. */
export function bertumpuk(a, b) {
  if (!a || !b) return false;
  if (a[2] - a[0] <= 0 || a[3] - a[1] <= 0 || b[2] - b[0] <= 0 || b[3] - b[1] <= 0) return false;
  return a[0] < b[2] && b[0] < a[2] && a[1] < b[3] && b[1] < a[3];
}

/** Tombol boleh tampil? `kotakNavigasi` = kotak sidebar, panel menu, dan bilah bawah yang terlihat. */
export function bolehTampil({ gulir, lebar, tinggi, kotakNavigasi = [] }) {
  if (!(gulir > 400)) return false;
  const zona = zonaTombol(lebar, tinggi);
  return !kotakNavigasi.some((k) => bertumpuk(zona, k));
}
